import { styled, component } from '../../utils/style';

interface MasonryColumnProps {
	columnNb: number;
}

export const StyledCustomMasonry = styled()(component.div, 'StyledCustomMasonry')`
	display: flex;
`;

export const MasonryColumn = styled<MasonryColumnProps>()(component.div, 'MasonryColumn')`
	display: flex;
    flex-direction: column;
	flex-basis: ${props => 100 / props.columnNb }%;
`;

export const MasonryItem = styled()(component.div, 'MasonryItem')`
	min-height: 1px;
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CustomMasonry/styles.ts